import React, { useMemo } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { useTranslation } from 'react-i18next';
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
// eslint-disable-next-line import/no-extraneous-dependencies
import { isAndroid, isIOS } from 'react-device-detect';
import HeaderContainer from '../../../../container/SectionContainer/Lazy';
import NavbarAuth from '../../../../container/NavbarContainer/Lazy';
import HeaderImg from '../../../../assets/img/bg-poli.svg';
import FooterSection from '../../../../container/FooterContainer/Lazy';
import style from './style.module.css';

function PoliJkn() {
  const { t } = useTranslation('common');

  const linkBPJS = useMemo(() => {
    if (isAndroid) {
      return 'https://play.google.com/store/apps/details?id=app.bpjs.mobile';
    } if (isIOS) {
      return 'https://apps.apple.com/id/app/mobile-jkn/id1237601115';
    }

    return 'https://jknmobile.com';
  }, []);

  const ctaLabel = isAndroid || isIOS ? t('poli.jknOpenApp') : t('poli.jknOpenWeb');

  return (
    <>
      <NavbarAuth />
      <HeaderContainer
        title={t('poli.gateTitle')}
        subtitle={t('poli.gateSubtitle')}
        image={HeaderImg}
        isSmall
      />
      <Container className="pt-5 pb-5">
        <div className={style.panel}>
          <div className={style.icon} aria-hidden="true">📱</div>
          <h2 className="font-poppins-900">{t('poli.jknTitle')}</h2>
          <p className={style.body}>{t('poli.jknBody')}</p>
          <a className={style.cta} href={linkBPJS}>{ctaLabel}</a>
          <div>
            <Link className={style.alt} to="/poli/jadwal">{t('poli.jknNotMember')}</Link>
          </div>
        </div>
      </Container>
      <FooterSection />
    </>
  );
}

export default React.memo(PoliJkn);
